import { useContext } from "react";
import { Block } from "generated/graphql";
import AnnotationMenu from "./AnnotationMenu";
import AnnotationEditor from "./AnnotationEditor";
import { AnnotationsContext } from "contexts/AnnotationsContext";

interface AnnotationSidebarProps {
  documentId: number;
  pageNumber: number;
  blocks: Block[];
}

const AnnotationSidebar = (props: AnnotationSidebarProps) => {
  const { annotationEditorOpen } = useContext(AnnotationsContext);

  return annotationEditorOpen ? (
    <AnnotationEditor blocks={props.blocks} documentId={props.documentId} pageNumber={props.pageNumber} />
  ) : (
    <AnnotationMenu />
  );
};

export default AnnotationSidebar;
